import styled from "styled-components";

export const HiddenContainer = styled.div<{ hidden: boolean }>`
    display: ${props => (props.hidden ? "none" : "initial")};
`;
